{
  "about.blocks": "Iqeddacen yettwaɛassen",
  "about.contact": "Anermis:",
  "about.default_locale": "Tamezwert",
  "about.disclaimer": "Mastodon d aseɣẓan ilelli, d aseɣẓan n uɣbalu yeldin, d tnezzut n Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Ulac taɣẓint",
  "about.domain_blocks.preamble": "Maṣṭudun s umata yeḍmen-ak ad teẓreḍ agbur, ad tesdemreḍ akked yimseqdacen-nniḍen seg yal aqeddac deg fedivers. Ha-tent-an ɣur-k tsuraf i yellan deg uqeddac-agi.",
  "about.domain_blocks.silenced.title": "Ɣur-s talast",
  "about.domain_blocks.suspended.title": "Yettwaḥbes",
  "about.language_label": "Tutlayt",
  "about.not_available": "Talɣut-a ur tettwabder ara deg uqeddac-a.",
  "about.powered_by": "Azeṭṭa inmetti yettwasɣelsen sɣur {mastodon}",
  "about.rules": "Ilugan n uqeddac",
  "account.account_note_header": "Tamawt tudmawant",
  "account.activity": "Armud",
  "account.add_note": "Rnu tazmilt tudmawant",
  "account.add_or_remove_from_list": "Rnu neɣ kkes seg tebdarin",
  "account.badges.admin": "Anedbal",
  "account.badges.blocked": "Yettusewḥel",
  "account.badges.bot": "Aṛubut",
  "account.badges.group": "Agraw",
  "account.badges.muted": "Yettwasgugem",
  "account.block": "Seḥbes @{name}",
  "account.block_domain": "Ffer kra i d-yekkan seg {domain}",
  "account.block_short": "Sewḥel",
  "account.blocked": "Yettusewḥel",
  "account.cancel_follow_request": "Sefsex taḍfart",
  "account.copy": "Nɣel assaɣ ɣer umaɣnu",
  "account.direct": "Bder-d @{name} weḥd-s",
  "account.disable_notifications": "Ḥbes ur iyi-d-ttazen ara ilɣa mi ara d-isuffeɣ @{name}",
  "account.edit_note": "Ẓreg tazmilt tudmawant",
  "account.edit_profile": "Ẓreg amaɣnu",
  "account.edit_profile_short": "Ẓreg",
  "account.enable_notifications": "Azen-iyi-d ilɣa mi ara d-isuffeɣ @{name}",
  "account.endorse": "Welleh fell-as deg umaɣnu-inek",
  "account.familiar_followers_many": "Yeṭṭafaṛ-it {name1} d {name2}, akked {othersCount, plural, one {yiwen nniḍen i tessneḍ} other {# nniḍen i tessneḍ}}",
  "account.familiar_followers_one": "Yeṭṭafar-it {name1}",
  "account.familiar_followers_two": "Yeṭṭafar-it {name1} akked {name2}",
  "account.featured": "Ufrinen",
  "account.featured.accounts": "Imeɣna",
  "account.featured.collections": "Tilkensa",
  "account.featured.new_collection": "Talkensit tamaynut",
  "account.field_overflow": "Wali akk agbur",
  "account.filters.all": "Akk irmad",
  "account.filters.boosts_toggle": "Sken-d izuzar",
  "account.filters.posts_boosts": "Tisuffaɣ akked tizuzar",
  "account.filters.posts_only": "Tisuffaɣ",
  "account.filters.posts_replies": "Tisuffaɣ d tririyin",
  "account.filters.replies_toggle": "Sken-d tiririyin",
  "account.follow": "Ḍfer",
  "account.follow_back": "Ḍfer-it ula d kečč·mm",
  "account.follow_back_short": "Ḍfer-it ula d kečč·mm",
  "account.follow_request": "Suter taḍfart",
  "account.follow_request_cancel": "Semmet asuter",
  "account.follow_request_cancel_short": "Semmet",
  "account.follow_request_short": "Asuter",
  "account.followers": "Imeḍfaren",
  "account.followers.empty": "Ar tura, ulac yiwen i yeṭṭafaṛen amseqdac-agi.",
  "account.followers_counter": "{count, plural, one {{counter} n umḍfar} other {{counter} n yimeḍfaren}}",
  "account.followers_you_know_counter": "Tessneḍ {counter}",
  "account.following": "Yeṭṭafaṛ",
  "account.following_counter": "{count, plural, one {{counter} yettwaḍfaren} other {{counter} yettwaḍfaren}}",
  "account.follows.empty": "Ar tura, amseqdac-agi ur yeṭṭafaṛ yiwen.",
  "account.follows_you": "Yeṭṭafaṛ-ik·em-id",
  "account.go_to_profile": "Ddu ɣer umaɣnu",
  "account.hide_reblogs": "Ffer ayen i ibeṭṭu @{name}",
  "account.join_modal.day": "Ass",
  "account.join_modal.me": "Terniḍ-d ɣer {server} ass n",
  "account.join_modal.me_today": "Ass-a, d ass-ik⋅im amezwaru deg {server}!",
  "account.join_modal.other": "{name} yerna-d ɣer {server} ass n",
  "account.join_modal.other_today": "D ass amezwaru n {name} ɣef {server}!",
  "account.join_modal.share.intro": "Bḍu izen anida deg-s ad temmeslayeḍ fell-ak⋅am",
  "account.join_modal.years": "{number, plural, one {n useggas} other {n iseggasen}}",
  "account.joined_short": "Izeddi da seg ass n",
  "account.languages": "Beddel tutlayin yettwajerden",
  "account.last_active": "Armud aneggaru",
  "account.link_verified_on": "Taɣara n useɣwen-a tettwasenqed ass n {date}",
  "account.locked_info": "Amiḍan-agi uslig isekweṛ. D bab-is kan i izemren ad yeǧǧ, s ufus-is, win ara t-iḍefṛen.",
  "account.media": "Timidyatin",
  "account.mention": "Bder-d @{name}",
  "account.menu.add_to_list": "Rnu ɣer tebdart…",
  "account.menu.block": "Sewḥel amiḍan",
  "account.menu.block_domain": "Sewḥel {domain}",
  "account.menu.copied": "Aseɣwen n umiḍan yettwanɣel ɣer tecwafit",
  "account.menu.copy": "Nɣel aseɣwen",
  "account.menu.mention": "Bder-d",
  "account.menu.mute": "Sgugem amiḍan",
  "account.menu.note.description": "Ad tettbin i kečč·mm kan",
  "account.menu.open_original_page": "Wali-t ɣef {domain}",
  "account.menu.remove_follower": "Kkes aneḍfar",
  "account.menu.report": "Cetki ɣef umiḍan-a",
  "account.menu.share": "Zuzer…",
  "account.menu.unblock": "Kkes asewḥel i umiḍan",
  "account.menu.unmute": "Kkes asgugem ɣef umiḍan",
  "account.moved_to": "{name} yenna-d dakken amiḍan-is amaynut yuɣal :",
  "account.mute": "Sgugem @{name}",
  "account.mute_notifications_short": "Susem ilɣa",
  "account.mute_short": "Sgugem",
  "account.muted": "Yettwasgugem",
  "account.mutual": "Temmeḍfaṛem",
  "account.name.copy": "Nɣel asulay",
  "account.name.help.header": "Asulay am tansa imayl",
  "account.name_info": "D acu i d lmeεna-s?",
  "account.no_bio": "Ulac aglam i d-yettunefken.",
  "account.node_modal.edit_title": "Ẓreg tazmilt tudmawant",
  "account.node_modal.error_unknown": "Ur izmir ara ad isekles tazmilt-a",
  "account.node_modal.field_label": "Tazmilt tudmawant",
  "account.node_modal.save": "Sekles",
  "account.node_modal.title": "Rnu tazmilt tudmawant",
  "account.note.edit_button": "Ẓreg",
  "account.note.title": "Tazmilt tudmawant (tettbin-d i kečč·mm kan)",
  "account.open_original_page": "Ldi asebter anasli",
  "account.pending": "Yettraǧu",
  "account.posts": "Tisuffaɣ",
  "account.remove_from_followers": "Kkes {name} seg ineḍfaren",
  "account.report": "Cetki ɣef @{name}",
  "account.requested_follow": "{name} yessuter ad k·m-yeḍfer",
  "account.share": "Bḍu amaɣnu n @{name}",
  "account.show_reblogs": "Sken-d izuzar n @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} n tsuffeɣt} other {{counter} n tsuffaɣ}}",
  "account.timeline.pinned": "Yettwasenṭeḍ",
  "account.timeline.pinned.view_all": "Wali akk tisuffaɣ tunṭiḍin",
  "account.unblock": "Serreḥ i @{name}",
  "account.unblock_domain": "Ssken-d {domain}",
  "account.unblock_domain_short": "Serreḥ",
  "account.unblock_short": "Serreḥ",
  "account.unendorse": "Ur ttwellih ara fell-as deg umaɣnu-inek",
  "account.unfollow": "Ur ṭṭafaṛ ara",
  "account.unmute": "Kkes asgugem ɣef @{name}",
  "account.unmute_notifications_short": "Serreḥ i yilɣa",
  "account.unmute_short": "Kkes asgugem",
  "account_edit.advanced_settings.bot_label": "Amiḍan awurman",
  "account_edit.advanced_settings.title": "Iɣewwaren leqqayen",
  "account_edit.bio.add_label": "Rnu tameddurt",
  "account_edit.bio.edit_label": "Ẓreg tameddurt",
  "account_edit.bio.title": "Tameddurt",
  "account_edit.bio_modal.add_title": "Rnu tameddurt",
  "account_edit.bio_modal.edit_title": "Ẓreg tameddurt",
  "account_edit.column_button": "Immed",
  "account_edit.column_title": "Ẓreg amaɣnu",
  "account_edit.custom_fields.add_label": "Rnu urti",
  "account_edit.custom_fields.edit_label": "Ẓreg urti",
  "account_edit.custom_fields.reorder_button": "Amizzwer n urtiyen",
  "account_edit.custom_fields.title": "Urtiyen udmawanen",
  "account_edit.custom_fields.verified_hint": "Amek ara rnuɣ aseɣwen yettuselknen?",
  "account_edit.display_name.add_label": "Rnu isem ara d-yettwaskanen",
  "account_edit.display_name.edit_label": "Ẓreg isem ara d-yettwaskanen",
  "account_edit.display_name.title": "Isem ara d-yettwaskanen",
  "account_edit.featured_hashtags.edit_label": "Rnu ihacṭagen",
  "account_edit.featured_hashtags.title": "Ihacṭagen ufrinen",
  "account_edit.field_actions.delete": "Kkes urti",
  "account_edit.field_actions.edit": "Ẓreg urti",
  "account_edit.field_delete_modal.delete_button": "Kkes",
  "account_edit.field_delete_modal.title": "Ad tekkseḍ urti udmawan?",
  "account_edit.field_edit_modal.add_title": "Rnu urti udmawan",
  "account_edit.field_edit_modal.discard_confirm": "Eǧǧ-it",
  "account_edit.field_edit_modal.edit_title": "Ẓreg urti udmawan",
  "account_edit.field_edit_modal.name_hint": "Amedya “Asmel-iw Web”",
  "account_edit.field_edit_modal.name_label": "Tabzimt",
  "account_edit.field_edit_modal.value_hint": "Amedya “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Azal",
  "account_edit.image_alt_modal.add_title": "Rnu aḍris amlellay",
  "account_edit.image_alt_modal.edit_title": "Ẓreg aḍris amlellay",
  "account_edit.image_alt_modal.text_label": "Aḍris amlellay",
  "account_edit.image_delete_modal.delete_button": "Kkes",
  "account_edit.image_delete_modal.title": "Ad tekkseḍ tugna?",
  "account_edit.image_edit.add_button": "Rnu tugna",
  "account_edit.image_edit.alt_add_button": "Rnu aḍris amlellay",
  "account_edit.image_edit.alt_edit_button": "Ẓreg aḍris amlellay",
  "account_edit.image_edit.remove_button": "Kkes tugna",
  "account_edit.image_edit.replace_button": "Semselsi tugna",
  "account_edit.item_list.delete": "Kkes {name}",
  "account_edit.item_list.edit": "Ẓreg {name}",
  "account_edit.name_modal.add_title": "Rnu isem ara d-yettwaskanen",
  "account_edit.name_modal.edit_title": "Ẓreg isem ara d-yettwaskanen",
  "account_edit.profile_tab.button_label": "Sagen",
  "account_edit.profile_tab.show_featured.title": "Sken-d accer n \"Ufrinen\"",
  "account_edit.save": "Sekles",
  "account_edit.upload_modal.back": "Uɣal",
  "account_edit.upload_modal.done": "Dayen",
  "account_edit.upload_modal.next": "Uḍfiṛ",
  "account_edit.upload_modal.step_crop.zoom": "Simɣeṛ",
  "account_edit.upload_modal.step_upload.button": "Snirem ifuyla",
  "account_edit.upload_modal.step_upload.dragging": "Ẓuɣer-it-id akken ad tt-saliḍt",
  "account_edit.upload_modal.step_upload.header": "Fren tugna",
  "account_edit.upload_modal.title_add.avatar": "Rnu tawlaft n umaɣnu",
  "account_edit.upload_modal.title_add.header": "Rnu tawlaft n tduli",
  "account_edit.upload_modal.title_replace.avatar": "Semselsi tawlaft n umaɣnu",
  "account_edit.upload_modal.title_replace.header": "Semselsi tawlaft n tduli",
  "account_edit.verified_modal.invisible_link.summary": "Amek ara rreɣ aseɣwen-nni ur yettban ara?",
  "account_edit.verified_modal.title": "Amek ara ternuḍ aseɣwen yettuselknen",
  "account_edit_tags.add_tag": "Rnu #{tagName}",
  "account_edit_tags.column_title": "Asiẓreg n yihacṭagen",
  "account_edit_tags.search_placeholder": "Sekcem-d ahacṭag…",
  "account_edit_tags.suggestions": "Isumren:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# n yizen} other {# n yiznan}}",
  "account_list.total": "{total, plural, one {# n umiḍan} other {# n imiḍanen}}",
  "account_note.placeholder": "Ulac iwenniten",
  "admin.dashboard.retention.cohort": "Ajerred deg ayyur",
  "admin.dashboard.retention.cohort_size": "Iseqdacen imaynuten",
  "alert.rate_limited.message": "Ma ulac aɣilif ɛreḍ tikelt-nniḍen akka {retry_time, time, medium}.",
  "alert.rate_limited.title": "Aktum s talast",
  "alert.unexpected.message": "Yeḍra-d unezri ur netturaǧu ara.",
  "alert.unexpected.title": "Ayhuh!",
  "alt_text_badge.title": "Aḍris amlellay",
  "alt_text_modal.add_alt_text": "Rnu aḍris amlellay",
  "alt_text_modal.add_text_from_image": "Rnu aḍris amlellay seg tugna",
  "alt_text_modal.cancel": "Semmet",
  "alt_text_modal.done": "Immed",
  "announcement.announcement": "Ulɣu",
  "annual_report.announcement.action_build": "Bnu-d Wrapstodon-inu",
  "annual_report.announcement.action_dismiss": "Uhu, tanemmirt",
  "annual_report.announcement.action_view": "Wali #Wrapstodon -iw",
  "annual_report.announcement.title": "Wrapstodon {year} yeweḍ-d",
  "annual_report.nav_item.badge": "Amaynut",
  "annual_report.shared_page.donate": "Mudd tawsa",
  "annual_report.shared_page.footer_server_info": "{username} yesseqdac {domain}, d yiwet ger waṭas n temɣiwanin i illeḥun s lmendad n Mastodon.",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.replier.name": "Aferteṭṭu",
  "annual_report.summary.archetype.reveal": "Sken-iyi-d amgenses-iw",
  "annual_report.summary.archetype.reveal_description": "Tanemmirt imi i tettekkaḍ deg Mastodon! D lawan ad tissineḍ anwa i d amgenses-ik·im deg useggas n {year}.",
  "annual_report.summary.archetype.title_public": "Amgenses n {name}",
  "annual_report.summary.archetype.title_self": "Amgenses-ik·im",
  "annual_report.summary.close": "Mdel",
  "annual_report.summary.copy_link": "Nɣel aseɣwen",
  "annual_report.summary.followers.new_followers": "{count, plural, one {n umedfaṛ amaynut} other {n imedfaṛen imaynuten}}",
  "annual_report.summary.most_used_app.most_used_app": "asnas yettwasqedcen s waṭas",
  "annual_report.summary.new_posts.new_posts": "tisuffaɣ timaynutin",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Ur as-neqqar i yiwen.",
  "annual_report.summary.share_elsewhere": "Zuzer-it anda nniḍen",
  "annual_report.summary.share_on_mastodon": "Zuzer-it ɣef Mastodon",
  "audio.hide": "Ffer amesli",
  "block_modal.show_less": "Ssken-d drus",
  "block_modal.show_more": "Ssken-d ugar",
  "block_modal.title": "Sewḥel aseqdac ?",
  "boost_modal.combo": "Tzemreḍ ad tsiteḍ ɣef {combo} akken ad tzegleḍ aya tikelt i d-iteddun",
  "boost_modal.reblog": "Zuzer tasuffeɣt?",
  "boost_modal.undo_reblog": "Semmet azuzer n yizen-a?",
  "bundle_column_error.copy_stacktrace": "Nɣel tuccḍa n uneqqis",
  "bundle_column_error.error.title": "Uh, ala !",
  "bundle_column_error.network.body": "Teḍra-d tuccḍa deg usali n usebter-a. Aya yezmer ad yili d ugur akudan deg tuqqna-inek·inem ɣer internet neɣ deg uqeddac-a.",
  "bundle_column_error.network.title": "Tuccḍa deg uẓeṭṭa",
  "bundle_column_error.retry": "Ɛreḍ tikelt-nniḍen",
  "bundle_column_error.return": "Uɣal ɣer ugejdan",
  "bundle_column_error.routing.body": "Asebter i d-yettwasutren ur yettwaf ara. Tetḥeqqeḍ belli tansa URL deg ufeggag n tansa tṣeḥḥa?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Mdel",
  "bundle_modal_error.retry": "Ɛreḍ tikelt-nniḍen",
  "callout.dismiss": "Zgel-it",
  "character_counter.required": "{currentLength}/{maxLength} n yisekkilen",
  "closed_registrations_modal.description": "Asnulfu n umiḍan deg {domain} mačči d ayen izemren ad yili, maca ttxil-k·m, err deg lbal-ik·im belli ur teḥwaǧeḍ ara amiḍan s wudem ibanen ɣef {domain} akken ad tesqedceḍ Mastodon.",
  "closed_registrations_modal.find_another_server": "Aff-d aqeddac nniḍen",
  "closed_registrations_modal.title": "Ajerred deg Masṭudun",
  "collection.share_modal.share_link_label": "Bḍu aseɣwen",
  "collection.share_modal.share_via_post": "Asuffeɣ deg Matodon",
  "collection.share_modal.share_via_system": "Zuzer s…",
  "collection.share_modal.title": "Bḍu talkensit",
  "collection.share_modal.title_new": "Zuzer talkensit-ik·im tamaynut!",
  "collections.account_count": "{count, plural, one {# n umiḍan} other {# n imiḍanen}}",
  "collections.accounts.empty_description": "Rnu alamma d {count} n imiḍanen",
  "collections.accounts.empty_editor_title": "Ulac ula yiwen ɛad deg telkensit-a",
  "collections.accounts.empty_title": "Talkensit-a d tilemt",
  "collections.block_collection_owner": "Sewḥel amiḍan",
  "collections.by_account": "sɣur {account_handle}",
  "collections.collection_description": "Aglam",
  "collections.collection_language": "Tutlayt",
  "collections.collection_language_none": "Ula yiwet",
  "collections.collection_name": "Isem",
  "collections.collection_topic": "Asentel",
  "collections.continue": "Kemmel",
  "collections.copy_link": "Nɣel aseɣwen",
  "collections.create.steps": "Asurif wis {step}/{total}",
  "collections.create_collection": "Snulfu-d talkensit",
  "collections.delete_collection": "Kkes talkensit",
  "collections.description_length_hint": "talast n 100 n yisekkilen",
  "collections.detail.author_added_you_on_date": "{author} yerna-k·em ass n {date}",
  "collections.detail.loading": "Aɛebbi n telkensit…",
  "collections.detail.revoke_inclusion": "Kkes-iyi",
  "collections.detail.sensitive_content": "Agbur amḥulfu",
  "collections.detail.share": "Zuzer talkensit-a",
  "collections.detail.you_are_in_this_collection": "Aql-ik⋅em ɣer sdat deg telsenkit-a",
  "collections.edit_details": "Ẓreg talqayt",
  "collections.hidden_accounts_link": "{count, plural, one {# n umiḍan uffir} other {# n imiḍanen yettwaffaren}}",
  "collections.hints.accounts_counter": "{count}/{max} n imiḍanen",
  "collections.last_updated_at": "Taẓrigt taneggarut: {date}",
  "collections.list.created_by_author": "D-yesnulfa {name}",
  "collections.list.created_by_you": "D-tesnulfaḍ",
  "collections.list.featuring_you": "Yid-k⋅m",
  "collections.manage_accounts": "Sefrek imiḍanen",
  "collections.name_length_hint": "talast n 40 n yisekkilen",
  "collections.new_collection": "Talkensit tamaynut",
  "collections.remove_account": "Kkes",
  "collections.report_collection": "Cetki ɣef telkensit-a",
  "collections.revoke_collection_inclusion": "Kkes-iyi seg telkensit-a",
  "collections.search_accounts_label": "Nadi ɣef umiḍan ara ternuḍ",
  "collections.share_short": "Bḍu",
  "collections.suggestions.can_not_add": "Ur tezmireḍ ara ad t-ternuḍt",
  "collections.view_collection": "Wali talkensit",
  "collections.visibility_public": "Azayaz",
  "collections.visibility_title": "Abani",
  "column.about": "Ɣef",
  "column.blocks": "Imiḍanen yettusḥebsen",
  "column.bookmarks": "Ticraḍ",
  "column.community": "Tasuddemt tadigant",
  "column.create_list": "Snulfu-d tabdart",
  "column.direct": "Tabdarin tusligin",
  "column.directory": "Inig deg imeɣna",
  "column.domain_blocks": "Taɣulin yeffren",
  "column.edit_list": "Ẓreg tabdart",
  "column.favourites": "Imenyafen",
  "column.firehose": "Isuddam usriden",
  "column.firehose_singular": "Asuddem usrid",
  "column.follow_requests": "Isuturen n teḍfeṛt",
  "column.home": "Agejdan",
  "column.list_members": "Sefrek iεeggalen n tebdart",
  "column.lists": "Tibdarin",
  "column.mutes": "Imiḍanen yettwasgugmen",
  "column.notifications": "Ilɣa",
  "column.other_collections": "Tilkensa sɣur {name}",
  "column.pins": "Tisuffaɣ yettwasenṭḍen",
  "column.public": "Tasuddemt tamatut",
  "column.your_collections": "Tilkensa-k·m",
  "column_back_button.label": "Tuɣalin",
  "column_header.hide_settings": "Ffer iɣewwaṛen",
  "column_header.moveLeft_settings": "Err ajgu ɣer tama tazelmaḍt",
  "column_header.moveRight_settings": "Err ajgu ɣer tama tayfust",
  "column_header.pin": "Senteḍ",
  "column_header.show_settings": "Ssken iɣewwaṛen",
  "column_header.unpin": "Kkes asenteḍ",
  "column_search.cancel": "Semmet",
  "combobox.close_results": "Mdel igmaḍ",
  "combobox.loading": "Yessalay-d",
  "combobox.no_results_found": "Ulac ugmaḍ yettwafen i unadi-a",
  "combobox.open_results": "Ldi igmaḍ",
  "community.column_settings.local_only": "Adigan kan",
  "community.column_settings.media_only": "Imidyaten kan",
  "community.column_settings.remote_only": "Anmeggag kan",
  "compose.error.blank_post": "Ur yezmir ara ad yili yizen d ilem.",
  "compose.language.change": "Beddel tutlayt",
  "compose.language.search": "Nadi tutlayin …",
  "compose.published.body": "Yeffeɣ-d yizen-nni.",
  "compose.published.open": "Ldi",
  "compose.saved.body": "Tettwasekles tsuffeɣt.",
  "compose_form.direct_message_warning_learn_more": "Issin ugar",
  "compose_form.encryption_warning": "",
  "compose_form.hashtag_warning": "",
  "compose_form.lock_disclaimer": "Amiḍan-ik·im ur yelli ara {locked}. Menwala yezmer ad k·kem-yeḍfeṛ akken ad iẓer acu tbeṭṭuḍ akked yimeḍfaṛen-ik·im.",
  "compose_form.lock_disclaimer.lock": "yettwacekkel",
  "compose_form.placeholder": "D acu i itezzin deg wallaɣ?",
  "compose_form.poll.duration": "Tanzagt n tefrant",
  "compose_form.poll.multiple": "Aṭas n ufran",
  "compose_form.poll.option_placeholder": "Taxtiṛt {number}",
  "compose_form.poll.single": "Yiwen wefran",
  "compose_form.poll.type": "Aɣanib",
  "compose_form.publish": "Suffeɣ",
  "compose_form.reply": "Err",
  "compose_form.save_changes": "Leqqem",
  "compose_form.spoiler.marked": "Kkes aḍris yettwaffren deffir n walɣu",
  "compose_form.spoiler.unmarked": "Rnu aḍris yettwaffren deffir n walɣu",
  "compose_form.spoiler_placeholder": "Alɣu n ugbur (afrayan)",
  "confirmation_modal.cancel": "Sefsex",
  "confirmations.block.confirm": "Sewḥel",
  "confirmations.delete.confirm": "Kkes",
  "confirmations.delete.message": "Tebɣiḍ s tidet ad tekkseḍ tasuffeɣt-agi?",
  "confirmations.delete.title": "Tukksa n tasuffeɣt?",
  "confirmations.delete_collection.confirm": "Kkes",
  "confirmations.delete_collection.title": "Ad tekkseḍ \"{name}\"?",
  "confirmations.delete_list.confirm": "Kkes",
  "confirmations.delete_list.message": "Tebɣiḍ s tidet ad tekkseḍ umuɣ-agi i lebda?",
  "confirmations.delete_list.title": "Tukksa n tebdart?",
  "confirmations.discard_draft.confirm": "Ttu-t u kemmel",
  "confirmations.discard_draft.edit.cancel": "Tuɣalin ar umaẓrag",
  "confirmations.discard_draft.edit.title": "Deggeṛ isenfal n yizen-ik·im?",
  "confirmations.discard_draft.post.cancel": "Tuɣalin ar urewway",
  "confirmations.discard_draft.post.title": "Deggeṛ arewway n yizen?",
  "confirmations.discard_edit_media.confirm": "Sefsex",
  "confirmations.follow_to_list.confirm": "Ḍfeṛ-it sakin rnu-t ɣer tebdart",
  "confirmations.follow_to_list.title": "Ḍfer aseqdac?",
  "confirmations.hide_featured_tab.confirm": "Ffer accer",
  "confirmations.hide_featured_tab.title": "Ffer accer n \"Ufrinen\"?",
  "confirmations.logout.confirm": "Ffeɣ",
  "confirmations.logout.message": "D tidet tebɣiḍ ad teffɣeḍ?",
  "confirmations.logout.title": "Tebɣiḍ ad teffɣeḍ ssya?",
  "confirmations.missing_alt_text.confirm": "Rnu aḍris amlellay",
  "confirmations.missing_alt_text.secondary": "Suffeɣ akken yebɣu yili",
  "confirmations.missing_alt_text.title": "Rnu aḍris amlellay?",
  "confirmations.mute.confirm": "Sgugem",
  "confirmations.private_quote_notify.cancel": "Tuɣalin ɣer usiẓreg",
  "confirmations.private_quote_notify.confirm": "Suffeɣ tasuffeɣt",
  "confirmations.private_quote_notify.do_not_show_again": "Ur-d skanay ara izen-a tikkelt-nniḍen",
  "confirmations.quiet_post_quote_info.dismiss": "Ur iyi-d-smektay ara",
  "confirmations.quiet_post_quote_info.got_it": "Gziɣ-t",
  "confirmations.redraft.confirm": "Kkes sakin ɛiwed tira",
  "confirmations.redraft.title": "Kkes sakin ɛiwed tira n tsuffeɣt?",
  "confirmations.remove_from_followers.confirm": "Kkes aneḍfar",
  "confirmations.revoke_collection_inclusion.confirm": "Kkes-iyi",
  "confirmations.revoke_quote.confirm": "Kkes tasuffeɣt",
  "confirmations.revoke_quote.title": "Kkes tasuffeɣt?",
  "confirmations.unblock.confirm": "Serreḥ",
  "confirmations.unblock.title": "Serreḥ i {name}?",
  "confirmations.unfollow.confirm": "Ur ḍḍafaṛ ara",
  "confirmations.unfollow.title": "Ḥbes aḍfar n {name}?",
  "confirmations.withdraw_request.confirm": "Agwi asuter",
  "content_warning.hide": "Ffer tasuffeɣt",
  "content_warning.show": "Ssken-d akken tebɣu tili",
  "content_warning.show_more": "Sken-d ugar",
  "content_warning.show_short": "Sken-d",
  "conversation.delete": "Kkes adiwenni",
  "conversation.mark_as_read": "Creḍ yettwaɣṛa",
  "conversation.open": "Ssken adiwenni",
  "conversation.with": "Akked {names}",
  "copy_icon_button.copied": "Yettwanɣel ɣer ufus",
  "copy_icon_button.copy_this_text": "Nɣel aseɣwen ɣer tecwafit",
  "copypaste.copied": "Yettwanɣel",
  "copypaste.copy_to_clipboard": "Nɣel ɣer afus",
  "directory.federated": "Deg fedivers yettwasnen",
  "directory.local": "Seg {domain} kan",
  "directory.new_arrivals": "Imaynuten id yewḍen",
  "directory.recently_active": "Yermed xas melmi kan",
  "disabled_account_banner.account_settings": "Iɣewwaṛen n umiḍan",
  "dismissable_banner.dismiss": "Agi",
  "domain_block_modal.block": "Sewḥel aqeddac",
  "domain_block_modal.block_account_instead": "Sewḥel @{name} deg nnuba-s",
  "domain_block_modal.they_cant_follow": "Yiwen ur yezmir ad k·m-id-yeḍfer seg uqeddac-a.",
  "domain_block_modal.they_wont_know": "Ur-d yettawi ara s lexbaṛ belli yettuseḥbes.",
  "domain_block_modal.title": "Sewḥel taɣult?",
  "domain_block_modal.you_wont_see_posts": "Ur tettuɣaleḍ ara ttwaliḍ tisuffaɣ neɣ ulɣuten n iseqdacen n uqeddac-a.",
  "domain_pill.activitypub_like_language": "ActivityPub am tutlayt yettmeslay Mastodon d izeḍwan inmettiyen nniḍen.",
  "domain_pill.server": "Aqeddac",
  "domain_pill.their_handle": "Asulay-is:",
  "domain_pill.username": "Isem n useqdac",
  "domain_pill.whats_in_a_handle": "D acu i yellan deg usulay?",
  "domain_pill.who_they_are": "Imi isulayen qqaren-d anwa i d yiwen d wanda yella, tzemreḍ ad temyigweḍ d yemdanen deg web anmetti yebnan s <button>tɣeṛɣaṛ yemmugen s ActivityPub</button>.",
  "domain_pill.who_you_are": "Imi isulay-ik·im yeqqar-d anwa i d kečč·kemmi d wanda i telliḍ, zemren medden ad myigwen yid-k·m deg web anmetti yebnan s <button>tɣeṛɣaṛ yemmugen s ActivityPub</button>.",
  "domain_pill.your_handle": "Asulay-ik·im:",
  "domain_pill.your_server": "D axxam-inek·inem umḍin, anda i zedɣent akk tsuffaɣ-ik·im. Ur k·m-yeεǧib ara wa? Ssenfel-d iqeddacen melmi i ak·m-yehwa, awi-d daɣen ineḍfaren-ik·im yid-k·m.",
  "dropdown.empty": "Fren taxtiṛit",
  "email_subscriptions.email": "Imayl",
  "email_subscriptions.submitted.title": "Yiwen n usurif nniḍen",
  "email_subscriptions.validation.email.invalid": "Tansa imayl d tarameɣtut",
  "embed.instructions": "Ẓẓu addad-agi deg usmel-inek·inem s wenɣal n tangalt yellan sdaw-agi.",
  "embed.preview": "Akka ara d-iban:",
  "emoji_button.activity": "Aqeddic",
  "emoji_button.clear": "Sfeḍ",
  "emoji_button.custom": "Udmawan",
  "emoji_button.flags": "Innayen",
  "emoji_button.food": "Tegwella & Tissit",
  "emoji_button.label": "Sekcem imuji",
  "emoji_button.nature": "Agama",
  "emoji_button.not_found": "Ulac izamulen n yiḥulfan  !! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Tiɣawsiwin",
  "emoji_button.people": "Medden",
  "emoji_button.recent": "Wid yettuseqdacen s waṭas",
  "emoji_button.search": "Nadi...",
  "emoji_button.search_results": "Igemmaḍ n unadi",
  "emoji_button.symbols": "Izamulen",
  "emoji_button.travel": "Imeḍqan d Yinigen",
  "empty_column.account_featured_self.no_collections_button": "Snulfu-d talkensit",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ɣumm accer-a",
  "empty_column.account_suspended": "Amiḍan yettwaḥbas",
  "empty_column.account_timeline": "Ulac tisuffaɣ da !",
  "empty_column.account_unavailable": "Ur nufi ara amaɣnu-ayi",
  "empty_column.blocks": "Ur tesḥebseḍ ula yiwen n umseqdac ar tura.",
  "empty_column.bookmarked_statuses": "Ulac kra n tsuffeɣt i terniḍ ɣer yismenyifen-ik·im ar tura. Ticki terniḍ yiwet, ad d-tettwasken da.",
  "empty_column.collections.featured_in": "Ur-k yerni ḥedd ɛad ɣer kra n telkensit.",
  "empty_column.community": "Tasuddemt tazayezt tadigant n yisallen d tilemt. Aru ihi kra akken ad tt-teččareḍ!",
  "empty_column.domain_blocks": "Ulac kra n taɣult yettwaffren ar tura.",
  "empty_column.explore_statuses": "Ulac ayen yellan d anezzuɣ akka tura. Uɣal-d ticki!",
  "empty_column.follow_requests": "Ulac ɣur-k·m ula yiwen n usuter n teḍfeṛt. Ticki teṭṭfeḍ-d yiwen ad d-yettwasken da.",
  "empty_column.hashtag": "Ar tura ulac kra n ugbur yesɛan assaɣ ɣer uhacṭag-agi.",
  "empty_column.home": "Tasuddemt tagejdant n yisallen d tilemt! Ẓer {public} neɣ nadi ad tafeḍ imseqdacen-nniḍen ad ten-ḍefṛeḍ.",
  "empty_column.list": "Ar tura ur yelli kra deg umuɣ-a. Ad d-yettwasken da ticki iɛeggalen n wumuɣ-a suffɣen-d kra.",
  "empty_column.mutes": "Ulac ɣur-k·m imseqdacen i yettwasgugmen.",
  "empty_column.notifications": "Ulac ɣur-k·m ilɣa. Sedmer akked yemdanen-nniḍen akken ad tebduḍ adiwenni.",
  "empty_column.public": "Ulac kra da! Aru kra, neɣ ḍfeṛ imdanen i yellan deg yiqeddacen-nniḍen akken ad d-teččar tsuddemt tazayezt",
  "empty_state.no_results": "Ulac igmaḍ",
  "error.unexpected_crash.next_steps": "Smiren asebter-a, ma ur yekkis ara wugur, ẓer d akken tzemreḍ ad tesqedceḍ Maṣṭudun deg yiminig-nniḍen neɣ deg usnas anaṣli.",
  "errors.unexpected_crash.copy_stacktrace": "Nɣel stacktrace ɣef wafus",
  "errors.unexpected_crash.report_issue": "Mmel ugur",
  "explore.suggested_follows": "Imdanen",
  "explore.title": "Inezzaɣ",
  "explore.trending_links": "Isallen",
  "explore.trending_statuses": "Tisuffaɣ",
  "explore.trending_tags": "Ihacṭagen",
  "featured_carousel.current": "<sr>Izen wis</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {n tsuffeɣt tunṭiḍt} other {n tsuffaɣ tunṭiḍin}}",
  "featured_carousel.slide": "Iznen {current, number} ɣef {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions.add": "Rnu",
  "featured_tags.suggestions.dismiss": "Uhu, tanemmirt",
  "filter_modal.added.review_and_configure_title": "Iɣewwaṛen n imzizdig",
  "filter_modal.added.settings_link": "asebter n yiɣewwaṛen",
  "filter_modal.added.short_explanation": "Tasuffeɣt-a tettwarna ɣer taggayt-a n yimsizdegen: {title}.",
  "filter_modal.added.title": "Yettwarna umsizdeg!",
  "filter_modal.select_filter.expired": "yemmut",
  "filter_modal.select_filter.prompt_new": "Taggayt tamaynutt : {name}",
  "filter_modal.select_filter.search": "Nadi neɣ snulfu-d",
  "filter_modal.select_filter.title": "Sizdeg tassufeɣt-a",
  "filter_modal.title.status": "Sizdeg tassufeɣt",
  "filtered_notifications_banner.title": "Ilɣa yettwasizdgen",
  "firehose.all": "Akk",
  "firehose.local": "Deg uqeddac-ayi",
  "firehose.remote": "Iqeddacen nniḍen",
  "follow_request.authorize": "Ssireg",
  "follow_request.reject": "Agi",
  "follow_suggestions.curated_suggestion": "Yettwafren sɣur tarbaɛt",
  "follow_suggestions.dismiss": "Dayen ur t-id-skan ara",
  "follow_suggestions.featured_longer": "Yettwafraned s ufus sɣur agraw n {domain}",
  "follow_suggestions.friends_of_friends_longer": "D aɣeṛfan ar wid i teṭṭafareḍ",
  "follow_suggestions.hints.featured": "Amaɣnu-a ifren-it-id wegraw n {domain} s ufus.",
  "follow_suggestions.hints.friends_of_friends": "Amaɣnu-a d aɣeṛfan ɣer wid i teṭṭafaṛeḍ.",
  "follow_suggestions.personalized_suggestion": "Asumer udmawan",
  "follow_suggestions.popular_suggestion": "Asumer aɣeṛfan",
  "follow_suggestions.popular_suggestion_longer": "D aɣeṛfan deg {domain}",
  "follow_suggestions.view_all": "Wali-ten akk",
  "follow_suggestions.who_to_follow": "Ad tḍefreḍ?",
  "followed_tags": "Ihacṭagen yettwaḍfaren",
  "followers.title": "Yeṭṭafaṛ {name}",
  "following.title": "Yeṭṭafar-it {name}",
  "footer.about": "Ɣef",
  "footer.about_mastodon": "Ɣef Mastodon",
  "footer.about_server": "Ɣef {domain}",
  "footer.about_this_server": "Ɣef",
  "footer.directory": "Akaram n imeɣna",
  "footer.get_app": "Awi-d asnas",
  "footer.keyboard_shortcuts": "Inegzumen n unasiw",
  "footer.privacy_policy": "Tasertit tabaḍnit",
  "footer.source_code": "Wali tangalt taɣbalut",
  "footer.status": "Addad",
  "footer.terms_of_service": "Tiwtilin n useqdec",
  "generic.saved": "Yettwasekles",
  "getting_started.heading": "Bdu",
  "hashtag.browse": "Snirem tisuffaɣ yesɛan #{hashtag}",
  "hashtag.browse_from_account": "Snirem tisuffaɣ sɣur @{name} yesɛan #{hashtag}",
  "hashtag.column_header.tag_mode.all": "d {additional}",
  "hashtag.column_header.tag_mode.any": "neɣ {additional}",
  "hashtag.column_header.tag_mode.none": "war {additional}",
  "hashtag.column_settings.select.no_options_message": "Ulac isumar",
  "hashtag.column_settings.select.placeholder": "Rnu-d ihacṭagen…",
  "hashtag.column_settings.tag_mode.all": "Kra yellan",
  "hashtag.column_settings.tag_mode.any": "Yiwen seg-sen",
  "hashtag.column_settings.tag_mode.none": "Yiwen ala seg-sen",
  "hashtag.column_settings.tag_toggle": "Glu-d s yihacṭagen imerna i ujgu-agi",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} imtekki} other {{counter} n imtekkiyen}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} n tsuffeɣt} other {{counter} n tsuffaɣ}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} n tsuffeɣt} other {{counter} n tsuffaɣ}} ass-a",
  "hashtag.feature": "Welleh fell-as deg umaɣnu-inek·inem",
  "hashtag.follow": "Ḍfeṛ ahacṭag",
  "hashtag.mute": "Sgugem #{hashtag}",
  "hashtag.unfeature": "Ur ttwellih ara fell-as deg umaɣnu-inek·inem",
  "hashtag.unfollow": "Ḥbes aḍfar n uhacṭag",
  "hashtags.and_other": "…d {count, plural, one {}other {# nniḍen}}",
  "hints.profiles.see_more_posts": "Wali ugar n tsuffaɣ ɣef {domain}",
  "home.column_settings.show_quotes": "Sken-d tibdarin",
  "home.column_settings.show_reblogs": "Sken-d izuzar",
  "home.column_settings.show_replies": "Ssken-d tiririyin",
  "home.hide_announcements": "Ffer ulɣuyen",
  "home.pending_critical_update.body": "Ma ulac aɣilif, leqqem aqeddac-ik Mastodon akken kan tzemreḍ !",
  "home.pending_critical_update.link": "Wali ileqman",
  "home.show_announcements": "Ssken-d ulɣuyen",
  "ignore_notifications_modal.ignore": "Ttu ilɣa",
  "info_button.label": "Tallelt",
  "interaction_modal.go": "Ddu",
  "interaction_modal.no_account_yet": "Werɛad ur tesɛid amiḍan?",
  "interaction_modal.on_another_server": "Deg uqeddac nniḍen",
  "interaction_modal.on_this_server": "Deg uqeddac-ayi",
  "interaction_modal.title": "Qqen i wakken ad tkemmleḍ",
  "interaction_modal.username_prompt": "Amedya: {example}",
  "intervals.full.days": "{number, plural, one {# wass} other {# wussan}}",
  "intervals.full.hours": "{number, plural, one {# usarag} other {# yisragen}}",
  "intervals.full.minutes": "{number, plural, one {# n tesdat} other {# n tesdatin}}",
  "keyboard_shortcuts.back": "i tuɣalin ɣer deffir",
  "keyboard_shortcuts.blocked": "akken ad teldiḍ umuɣ n yimseqdacen yettwasḥebsen",
  "keyboard_shortcuts.boost": "i beṭṭu tikelt-nniḍen",
  "keyboard_shortcuts.column": "to focus a status in one of the columns",
  "keyboard_shortcuts.compose": "to focus the compose textarea",
  "keyboard_shortcuts.description": "Aglam",
  "keyboard_shortcuts.down": "i kennu ɣer wadda n tebdart",
  "keyboard_shortcuts.enter": "i tildin n tsuffeɣt",
  "keyboard_shortcuts.favourite": "Smenyef tassuɣeft",
  "keyboard_shortcuts.favourites": "Ldi tabdert n yismenyifen",
  "keyboard_shortcuts.federated": "i tildin n tsuddemt tamatut n yisallen",
  "keyboard_shortcuts.heading": "Inegzumen n unasiw",
  "keyboard_shortcuts.home": "i tildin n tsuddemt tagejdant n yisallen",
  "keyboard_shortcuts.hotkey": "Inegzumen",
  "keyboard_shortcuts.legend": "akken ad tsekneḍ taneffust-agi",
  "keyboard_shortcuts.local": "i tildin n tsuddemt tadigant n yisallen",
  "keyboard_shortcuts.mention": "akken ad d-bedreḍ ameskar",
  "keyboard_shortcuts.muted": "akken ad teldiḍ tabdart n yimseqdacen yettwasgugmen",
  "keyboard_shortcuts.my_profile": "akken ad d-teldiḍ amaɣnu-ik",
  "keyboard_shortcuts.notifications": "Ad d-yeldi ajgu n yilɣa",
  "keyboard_shortcuts.open_media": "i tiɣwalin yeldin",
  "keyboard_shortcuts.pinned": "akken ad teldiḍ tabdart n tsuffaɣ tunṭiḍin",
  "keyboard_shortcuts.profile": "akken ad d-teldiḍ amaɣnu n umeskar",
  "keyboard_shortcuts.quote": "Tanebdurt n tsuffeɣt",
  "keyboard_shortcuts.reply": "i tririt",
  "keyboard_shortcuts.requests": "akken ad d-teldiḍ tabdert n yisuturen n teḍfeṛt",
  "keyboard_shortcuts.search": "to focus search",
  "keyboard_shortcuts.spoilers": "i uskan/tuffra n wurti CW",
  "keyboard_shortcuts.start": "akken ad d-teldiḍ ajgu n \"bdu\"",
  "keyboard_shortcuts.toggle_hidden": "i uskan/tuffra n uḍris deffir CW",
  "keyboard_shortcuts.toggle_sensitivity": "i teskent/tuffra n yimidyaten",
  "keyboard_shortcuts.toot": "i wakken attebdud tajewwaqt tamaynut",
  "keyboard_shortcuts.translate": "i usuqel n tsuffeɣt",
  "keyboard_shortcuts.unfocus": "to un-focus compose textarea/search",
  "keyboard_shortcuts.up": "i tulin ɣer d asawen n tebdart",
  "learn_more_link.got_it": "Gziɣ-t",
  "learn_more_link.learn_more": "Issin ugar",
  "lightbox.close": "Mdel",
  "lightbox.next": "Ɣer zdat",
  "lightbox.previous": "Ɣer deffir",
  "limited_account_hint.action": "Wali amaɣnu akken yebɣu yili",
  "link_preview.author": "S-ɣur {name}",
  "link_preview.more_from_author": "Ugar sɣur {name}",
  "link_preview.shares": "{count, plural, one {{counter} n tsuffeɣt} other {{counter} n tsuffaɣ}}",
  "lists.add_member": "Rnu",
  "lists.add_to_list": "Rnu ɣer tebdart",
  "lists.add_to_lists": "Rnu {name} ɣer tebdarin",
  "lists.create": "Snulfu-d",
  "lists.create_list": "Snulfu-d tabdart",
  "lists.delete": "Kkes tabdart",
  "lists.done": "Immed",
  "lists.edit": "Ẓreg tabdart",
  "lists.find_users_to_add": "Af-d iseqdacen ara ternuḍ",
  "lists.list_members_count": "{count, plural, one {# n uɛeggal} other {# n iɛeggalen}}",
  "lists.list_name": "Isem n tebdart",
  "lists.new_list_name": "Isem n tebdart tamaynut",
  "lists.no_lists_yet": "Ulac tibdarin akka tura.",
  "lists.no_members_yet": "Ulac iɛeggalen akka tura.",
  "lists.no_results_found": "Ulac igemmad.",
  "lists.remove_member": "Kkes",
  "lists.replies_policy.followed": "Kra n useqdac i yettwaḍefren",
  "lists.replies_policy.list": "Iɛeggalen n tebdart",
  "lists.replies_policy.none": "Ula yiwen·t",
  "lists.save": "Sekles",
  "lists.search": "Nadi",
  "load_pending": "{count, plural, one {# n uferdis amaynut} other {# n yiferdisen imaynuten}}",
  "loading_indicator.label": "Yessalay-d …",
  "media_gallery.hide": "Seggelmes",
  "mute_modal.hide_from_notifications": "Ffer-it deg ulɣuten",
  "mute_modal.hide_options": "Ffer tinefrunin",
  "mute_modal.indefinite": "Alamma ssnesreɣ asgugem fell-as",
  "mute_modal.show_options": "Sken-d tinefrunin",
  "mute_modal.they_can_mention_and_follow": "Yezmer ad k·m-id-yebder, ad k·m-yeḍfer, maca ur t-tettwaliḍt ara.",
  "mute_modal.they_wont_know": "Ur yezmir ara ad iẓer dakken tesgugmeṭ.",
  "mute_modal.title": "Asgugem n useqdac?",
  "mute_modal.you_wont_see_mentions": "Ur tezmireḍ ara ad twaliḍ tisuffaɣ anda d-yettwabdar.",
  "mute_modal.you_wont_see_posts": "Yezmer ad yettwali tisuffaɣ-ik·im, maca ur tettwaliḍ ara tidak-is.",
  "navigation_bar.about": "Ɣef",
  "navigation_bar.account_settings": "Awal n uɛeddi akked tɣellist",
  "navigation_bar.administration": "Tadbelt",
  "navigation_bar.advanced_interface": "Ldi deg ugrudem n web leqqayen",
  "navigation_bar.automated_deletion": "Tukksa tawurmant n tsuffaɣ",
  "navigation_bar.blocks": "Iseqdacen yettusḥebsen",
  "navigation_bar.bookmarks": "Ticraḍ",
  "navigation_bar.collections": "Tilkensa",
  "navigation_bar.direct": "Tibdarin tusligin",
  "navigation_bar.domain_blocks": "Tiɣula yeffren",
  "navigation_bar.favourites": "Imenyafen",
  "navigation_bar.filters": "Awalen i yettwasgugmen",
  "navigation_bar.follow_requests": "Isuturen n teḍfeṛt",
  "navigation_bar.followed_tags": "Ihacṭagen yettwaḍfaren",
  "navigation_bar.follows_and_followers": "Imeḍfaṛen akked wid i teṭṭafaṛeḍ",
  "navigation_bar.import_export": "Taktert d usifeḍ",
  "navigation_bar.lists": "Tibdarin",
  "navigation_bar.live_feed_local": "Asuddem usrid (adigan)",
  "navigation_bar.live_feed_public": "Asuddem usrid (azayaz)",
  "navigation_bar.logout": "Ffeɣ",
  "navigation_bar.moderation": "Aseɣyed",
  "navigation_bar.more": "Ugar",
  "navigation_bar.mutes": "Iseqdacen yettwasusmen",
  "navigation_bar.opened_in_classic_interface": "Tisuffaɣ, imiḍanen akked isebtar-nniḍen igejdanen ldin-d s wudem amezwer deg ugrudem web aklasiki.",
  "navigation_bar.preferences": "Imenyafen",
  "navigation_bar.privacy_and_reach": "Tabḍnit akked wagwaḍ",
  "navigation_bar.search": "Nadi",
  "navigation_bar.search_trends": "Anadi / Anezzuɣ",
  "navigation_panel.collapse_lists": "Sneḍfes umuɣ n tebdart",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.added_to_collection": "{name} yerna-k·em ɣer yiwen n telkensit",
  "notification.admin.report": "Yemla-t-id {name} {target}",
  "notification.admin.sign_up": "Ijerred {name}",
  "notification.annual_report.view": "Wali #Wrapstodon",
  "notification.favourite": "{name} yesmenyaf addad-ik·im",
  "notification.favourite_pm": "{name} yesmenyef abdar-ik·im uslig",
  "notification.favourite_pm.name_and_others_with_link": "{name} akked <a>{count, plural, one {# nnayeḍ} other {# nniḍen}}</a> rnan abdar-ik·im uslig ar ismenyafen-nsen",
  "notification.follow": "iṭṭafar-ik·em-id {name}",
  "notification.follow.name_and_others": "{name} akked <a>{count, plural, one {# nniḍen} other {# nniḍen}}</a> iḍfeṛ-k·m-id",
  "notification.follow_request": "{name} yessuter-d ad k·m-yeḍfeṛ",
  "notification.follow_request.name_and_others": "{name} d {count, plural, one {# nnayeḍ} other {# nniḍen}} yessuter-d ad k·kem-yeḍfer",
  "notification.label.mention": "Abdar",
  "notification.label.private_mention": "Abdar uslig",
  "notification.label.private_reply": "Tiririt tusligt",
  "notification.label.reply": "Tiririt",
  "notification.mention": "Abdar",
  "notification.mentioned_you": "{name} yebder-ik·em-id",
  "notification.moderation-warning.learn_more": "Issin ugar",
  "notification.moderation_warning.action_suspend": "Yettwaseḥbes umiḍan-ik.",
  "notification.own_poll": "Tafrant-ik·im tfuk",
  "notification.reblog": "{name} yebḍa tajewwiqt-ik i tikelt-nniḍen",
  "notification.reblog.name_and_others_with_link": "{name} akked <a>{count, plural, one {# nnayeḍ} other {# nniḍen}}</a> zzuzren tasuffeɣt-ik·im",
  "notification.relationships_severance_event.learn_more": "Issin ugar",
  "notification.status": "{name} akken i d-yessufeɣ",
  "notification.update": "{name} ibeddel tira n yiwen n yizen",
  "notification_requests.accept": "Qbel",
  "notification_requests.dismiss": "Agi",
  "notification_requests.edit_selection": "Ẓreg",
  "notification_requests.exit_selection": "Immed",
  "notification_requests.notifications_from": "Ilɣa sɣur {name}",
  "notification_requests.title": "Ilɣa yettwasizdgen",
  "notification_requests.view": "Wali ilɣa",
  "notifications.clear": "Sfeḍ ilɣa",
  "notifications.clear_confirmation": "Tebɣiḍ s tidet ad tekkseḍ akk ilɣa-inek·em i lebda?",
  "notifications.clear_title": "Sfeḍ ilɣa?",
  "notifications.column_settings.admin.report": "Ineqqisen imaynuten:",
  "notifications.column_settings.alert": "Ilɣa n tnarit",
  "notifications.column_settings.favourite": "Imenyafen:",
  "notifications.column_settings.filter_bar.advanced": "Sken-d akk taggayin",
  "notifications.column_settings.filter_bar.category": "Iri n usizdeg uzrib",
  "notifications.column_settings.follow": "Imeḍfaṛen imaynuten:",
  "notifications.column_settings.follow_request": "Isuturen imaynuten n teḍfeṛt:",
  "notifications.column_settings.group": "Agraw",
  "notifications.column_settings.mention": "Abdar:",
  "notifications.column_settings.poll": "Igemmaḍ n usenqed:",
  "notifications.column_settings.push": "Ilɣa yettudemmren",
  "notifications.column_settings.quote": "Yebder-d:",
  "notifications.column_settings.reblog": "Seǧhed:",
  "notifications.column_settings.show": "Ssken-d tilɣa deg ujgu",
  "notifications.column_settings.sound": "Rmed imesli",
  "notifications.column_settings.status": "Tisuffaɣ timaynutin :",
  "notifications.column_settings.unread_notifications.category": "Ilɣa ur nettwaɣra",
  "notifications.column_settings.update": "Iẓreg:",
  "notifications.filter.all": "Akk",
  "notifications.filter.boosts": "Seǧhed",
  "notifications.filter.favourites": "Imenyafen",
  "notifications.filter.follows": "Yeṭafaṛ",
  "notifications.filter.mentions": "Abdar",
  "notifications.filter.polls": "Igemmaḍ n usenqed",
  "notifications.filter.statuses": "Ileqman n yimdanen i teṭṭafareḍ",
  "notifications.grant_permission": "Mudd tasiregt.",
  "notifications.group": "{count} n yilɣa",
  "notifications.mark_as_read": "Creḍ akk ilɣa am wakken ttwaɣran",
  "notifications.permission_denied": "D awezɣi ad yili wermad n yilɣa n tnarit axateṛ turagt tettwagdel",
  "notifications.policy.accept": "Qbel",
  "notifications.policy.drop": "Anef-as",
  "notifications.policy.filter": "Sizdeg",
  "notifications.policy.filter_new_accounts.hint": "Imiḍanen imaynuten i d-yennulfan deg {days, plural, one {yiwen n wass} other {# n wussan}} yezrin",
  "notifications.policy.filter_new_accounts_title": "Imiḍan imaynuten",
  "notifications.policy.filter_not_followers_hint": "Ula d wid akked tid i k·m-id-iḍefren, ur wwiḍen ara {days, plural, one {yiwen wass} other {# wussan}}",
  "notifications.policy.filter_not_followers_title": "Wid akked tid ur k·m-id-yeṭṭafaren ara",
  "notifications.policy.filter_not_following_hint": "Alamma tqebleḍ-ten s ufus",
  "notifications.policy.filter_not_following_title": "Wid akked tid ur tettḍafareḍ ara",
  "notifications.policy.filter_private_mentions_title": "Abdar uslig ur yettwasferken ara",
  "notifications_permission_banner.enable": "Rmed ilɣa n tnarit",
  "notifications_permission_banner.title": "Ur zeggel acemma",
  "onboarding.follows.back": "Uɣal",
  "onboarding.follows.next": "Uḍfir: Swel amaɣnu-inek⋅inem",
  "onboarding.follows.search": "Nadi",
  "onboarding.follows.title": "Ḍfeṛ walbɛaḍ i wakken ad ttebdud",
  "onboarding.profile.discoverable": "Err amaɣnu-inu ad yettwaf",
  "onboarding.profile.display_name": "Isem ara d-yettwaskanen",
  "onboarding.profile.display_name_hint": "Isem-ik·im ummid neɣ isem-ik·im n uqeṣṣer…",
  "onboarding.profile.finish": "Kfu",
  "onboarding.profile.note": "Tameddurt",
  "onboarding.profile.note_hint": "Tzemreḍ ad d-@tbedreḍ imdanen niḍen neɣ #ihacṭagen …",
  "onboarding.profile.title": "Asbadu n umaɣnu",
  "onboarding.profile.upload_avatar": "Sali tugna n umaɣnu",
  "onboarding.profile.upload_header": "Sali tacacit n umaɣnu",
  "password_confirmation.mismatching": "Asentem n wawal n uɛeddi ur yemṣada ara",
  "picture_in_picture.restore": "Err-it amkan-is",
  "poll.closed": "Tfukk",
  "poll.refresh": "Smiren",
  "poll.reveal": "Wali igmaḍ",
  "poll.total_people": "{count, plural, one {# n wemdan} other {# n yemdanen}}",
  "poll.total_votes": "{count, plural, one {# n udɣaṛ} other {# n yedɣaṛen}}",
  "poll.vote": "Dɣeṛ",
  "poll.voted": "Tdeɣṛeḍ ɣef tririt-ayi",
  "poll.votes": "{votes, plural, one {# n udɣaṛ} other {# n yedɣaṛen}}",
  "poll_button.add_poll": "Rnu asenqed",
  "poll_button.remove_poll": "Kkes asenqed",
  "privacy.change": "Seggem tabaḍnit n yizen",
  "privacy.direct.long": "Wid akk i d-yettwabdaren deg tsuffeɣt",
  "privacy.direct.short": "Abdar uslig",
  "privacy.private.long": "Ala wid i k·m-yeṭṭafaṛen",
  "privacy.private.short": "Imeḍfaren",
  "privacy.public.long": "Kra n win yellan deg Masṭudun neɣ berra-s",
  "privacy.public.short": "Azayez",
  "privacy.unlisted.short": "Azayez asusam",
  "privacy_policy.last_updated": "Aleqqem aneggaru {date}",
  "privacy_policy.title": "Tasertit tabaḍnit",
  "recommended": "Yettuwelleh",
  "refresh": "Smiren",
  "regeneration_indicator.please_stand_by": "Ttxil rǧu.",
  "regeneration_indicator.preparing_your_home_feed": "Ha-tt-an tsuddemt-ik·im tagejdant tettwaheggay…",
  "relative_time.days": "{number}u",
  "relative_time.full.days": "{number, plural, one {# n wass} other {# n wussan}} aya",
  "relative_time.full.hours": "{number, plural, one {# n usrag} other {# n yesragen}} aya",
  "relative_time.full.just_now": "tura kan",
  "relative_time.hours": "{number}isr",
  "relative_time.just_now": "tura",
  "relative_time.minutes": "{number}tis",
  "relative_time.seconds": "{number}tas",
  "relative_time.today": "ass-a",
  "remove_quote_hint.button_label": "Gziɣ-t",
  "remove_quote_hint.title": "D tidet, tebɣiḍ ad tekkseḍ tasuffeɣt-inek·inem i d-yettwabedren?",
  "reply_indicator.attachments": "{count, plural, one {# n umedday} other {# n imeddayen}}",
  "reply_indicator.cancel": "Sefsex",
  "reply_indicator.poll": "Afmiḍi",
  "report.block": "Sewḥel",
  "report.categories.legal": "Azerfan",
  "report.categories.other": "Tiyyaḍ",
  "report.categories.spam": "Aspam",
  "report.category.subtitle": "Fren amṣada akk ufrin",
  "report.category.title": "Ini-aɣ-d d acu i yuɣen {type}-a",
  "report.category.title_account": "ameɣnu",
  "report.category.title_status": "tasuffeɣt",
  "report.close": "Immed",
  "report.forward": "Bren-it ɣeṛ {target}",
  "report.mute": "Sgugem",
  "report.next": "Uḍfiṛ",
  "report.placeholder": "Iwenniten-nniḍen",
  "report.reasons.dislike": "Ur t-ḥemmleɣ ara",
  "report.reasons.dislike_description": "D ayen akk ur bɣiɣ ara ad waliɣ",
  "report.reasons.other": "D ayen nniḍen",
  "report.reasons.other_description": "Ugur ur yemṣada ara akk d taggayin-nniḍen",
  "report.reasons.spam": "D aspam",
  "report.reasons.spam_description": "Yir iseɣwan, yir agman d tririyin i d-yettuɣalen",
  "report.reasons.violation": "Truẓi n yilugan n uqeddac",
  "report.reasons.violation_description": "Teẓriḍ y·tettruẓu kra n yilugan",
  "report.rules.subtitle": "Fren ayen akk yemṣadan",
  "report.rules.title": "Acu n yilugan i yettwarẓan?",
  "report.statuses.subtitle": "Fren ayen akk yemṣadan",
  "report.statuses.title": "Llant tsuffaɣ ara isdemren aneqqis-a?",
  "report.submit": "Azen",
  "report.target": "Mmel {target}",
  "report.thanks.take_action_actionable": "Ideg nekkni nessenqad tuttra-inek•inem, tzemreḍ ad tḥadreḍ mgal @{name}:",
  "report.thanks.title": "Ur tebɣiḍ ara ad twaliḍ aya?",
  "report.thanks.title_actionable": "Tanemmirt ɣef uneqqis, ad nwali deg waya.",
  "report.unfollow": "Seḥbes aḍfar n @{name}",
  "report.unfollow_explanation": "Aql-ik·ikem teṭṭafareḍ amiḍan-a. I wakken ur tettwaliḍ ara akk, akka d asawen, tisuffaɣ-is deg tsuddemt-ik·im tagejdant, ur teṭṭafar ara.",
  "report_notification.attached_statuses": "{count, plural, one {{count} n tsuffeɣt} other {{count} n tsuffiɣin}} ttwaqnent",
  "report_notification.categories.legal": "Azerfan",
  "report_notification.categories.other": "Ayen nniḍen",
  "report_notification.categories.other_sentence": "ayen nniḍen",
  "report_notification.categories.spam": "Aspam",
  "report_notification.categories.spam_sentence": "aspam",
  "report_notification.open": "Ldi aneqqis",
  "search.clear": "Sfeḍ anadi",
  "search.no_recent_searches": "Ulac inadiyen ineggura",
  "search.placeholder": "Nadi",
  "search.quick_action.account_search": "Imaɣnuten mṣadan d {x}",
  "search.quick_action.go_to_account": "Ddu ɣer umaɣnu {x}",
  "search.quick_action.go_to_hashtag": "Ddu ɣer uhacṭag {x}",
  "search.quick_action.open_url": "Ldi tansa URL deg Mastodon",
  "search.quick_action.status_search": "Tisuffaɣ mṣadan d {x}",
  "search.search_or_paste": "Nadi neɣ senṭeḍ URL",
  "search_popout.full_text_search_disabled_message": "Ur yelli ara deg {domain}.",
  "search_popout.full_text_search_logged_out_message": "Yella kan mi ara tiliḍ d uqqin.",
  "search_popout.language_code": "Tangalt ISO n tutlayt",
  "search_popout.options": "Iwellihen n unadi",
  "search_popout.quick_actions": "Tigawin tiruradin",
  "search_popout.recent": "Inadiyen ineggura",
  "search_popout.user": "amseqdac",
  "search_results.accounts": "Imeɣna",
  "search_results.all": "Akk",
  "search_results.hashtags": "Ihacṭagen",
  "search_results.no_results": "Ulac igemmaḍ.",
  "search_results.no_search_yet": "Ɛreḍ ad d-tnadiḍ ɣef iznan, imaɣnuten neɣ ihacṭagen.",
  "search_results.see_all": "Wali-ten akk",
  "search_results.statuses": "Tisuffaɣ",
  "search_results.title": "Igemmaḍ n unadi ɣef \"{q}\"",
  "server_banner.active_users": "iseqdacen urmiden",
  "server_banner.administered_by": "Yettwadbel sɣur :",
  "server_banner.is_one_of_many": "{domain} d yiwen seg seg waṭṭas n iqeddacen imzurag n Mastodon i tzemreḍ ad tsqesdceḍ i wakken ad tettekkiḍ deg fediverse.",
  "server_banner.more_about_this_server": "Issin ugar ɣef uqeddac-a",
  "server_banner.server_stats": "Tidaddanin n uqeddac:",
  "sign_in_banner.create_account": "Snulfu-d amiḍan",
  "sign_in_banner.sign_in": "Qqen",
  "sign_in_banner.sso_redirect": "Qqen neɣ jerred",
  "skip_links.skip_to_content": "Kcem ɣer ugbur agejdan",
  "skip_links.skip_to_navigation": "Kcem ɣer tunigin tagejdant",
  "status.admin_status": "Open this status in the moderation interface",
  "status.block": "Seḥbes @{name}",
  "status.bookmark": "Creḍ",
  "status.cancel_reblog_private": "Sefsex beṭṭu",
  "status.cannot_reblog": "Tasuffeɣt-a ur tezmir ara ad tettwabḍu tikelt-nniḍen",
  "status.contains_quote": "Yegber tanebdurt",
  "status.context.loading": "Aɛebbi n tririyin nniḍen",
  "status.context.loading_success": "Ttuɛebbant-d tririyin timaynutin",
  "status.context.more_replies_found": "Ugar n tririyin ttwafent",
  "status.context.retry": "Ɛreḍ tikkelt nniḍen",
  "status.context.show": "Sken-d",
  "status.continued_thread": "Asqerdec yettkemmil",
  "status.copy": "Nɣel assaɣ ɣer tasuffeɣt",
  "status.delete": "Kkes",
  "status.delete.success": "Tettwakkes tsuffeɣt",
  "status.direct": "Bder-d @{name} weḥd-s",
  "status.direct_indicator": "Abdar uslig",
  "status.edit": "Ẓreg",
  "status.edited": "Taẓrigt taneggarut {date}",
  "status.edited_x_times": "Tettwaẓreg {count, plural, one {{count} n tikkelt} other {{count} n tikkal}}",
  "status.embed": "Awi-d tangalt n weslaɣ",
  "status.favourite": "Amenyaf",
  "status.filter": "Sizdeg tassufeɣt-a",
  "status.history.created": "Yerna-t {name} {date}",
  "status.history.edited": "Ibeddel-it {name} {date}",
  "status.load_more": "Sali ugar",
  "status.media.open": "Sit i ulday",
  "status.media.show": "Sit i uskan",
  "status.media_hidden": "Amidya yettwaffer",
  "status.mention": "Bder-d @{name}",
  "status.more": "Ugar",
  "status.mute": "Sussem @{name}",
  "status.mute_conversation": "Sgugem adiwenni",
  "status.open": "Semɣeṛ tasuffeɣt-ayi",
  "status.pin": "Senteḍ-itt deg umaɣnu",
  "status.quote": "Tanebdurt",
  "status.quote.cancel": "Semmet tanebdurt",
  "status.quote_error.limited_account_hint.action": "Sken-d akken ibɣu yili",
  "status.quote_error.not_available": "Tasuffeɣt-a ulac-itt",
  "status.quote_error.revoked": "Tasuffeɣt-a yekkes-itt umeskar-is",
  "status.quote_noun": "Tanebdurt",
  "status.quote_policy_change": "Snifel anwa i izemren ad d-yebder",
  "status.quote_post_author": "Yebder-d tasuffeɣt sɣur @{name}",
  "status.quotes_count": "{count, plural, one {{counter} n tnebdurt} other {{counter} n tnebdurin}}",
  "status.read_more": "Issin ugar",
  "status.reblog": "Bḍu",
  "status.reblog_or_quote": "Zuzer neɣ ader-d",
  "status.reblogged_by": "Yebḍa-tt {name}",
  "status.reblogs.empty": "Ula yiwen ur yebḍi tajewwiqt-agi ar tura. Ticki yebḍa-tt yiwen, ad d-iban da.",
  "status.reblogs_count": "{count, plural, one {{counter} n uzuzer} other {{counter} n yizuzar}}",
  "status.redraft": "Kkes tɛiwdeḍ tira",
  "status.remove_bookmark": "Kkes tacreḍt",
  "status.remove_quote": "Kkes",
  "status.replied_in_thread": "Y·t·erra-d deg usqerdec",
  "status.replied_to": "Y·terra-yas i {name}",
  "status.reply": "Err",
  "status.replyAll": "Err i wesqerdec",
  "status.report": "Cetki ɣef @{name}",
  "status.request_quote": "Suter tabdert",
  "status.sensitive_warning": "Agbur amḥulfu",
  "status.share": "Bḍu",
  "status.show_less_all": "Semẓi akk tisuffɣin",
  "status.show_more_all": "Ẓerr ugar lebda",
  "status.show_original": "Sken aɣbalu",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Suqel",
  "status.translated_from_with": "Tettwasuqel seg {lang} s {provider}",
  "status.uncached_media_warning": "Ulac taskant",
  "status.unmute_conversation": "Kkes asgugem n udiwenni",
  "status.unpin": "Kkes asenteḍ seg umaɣnu",
  "subscribed_languages.save": "Sekles ibeddilen",
  "tabs_bar.home": "Agejdan",
  "tabs_bar.menu": "Umuɣ",
  "tabs_bar.notifications": "Ilɣa",
  "tabs_bar.publish": "Tasuffeɣt tamaynut",
  "tabs_bar.search": "Nadi",
  "tag.remove": "Kkes",
  "terms_of_service.title": "Tiwtilin n useqdec",
  "time_remaining.days": "Mazal {number, plural, one {# wass} other {# wussan}}",
  "time_remaining.hours": "Mazal {number, plural, one {# usarag} other {# yisragen}}",
  "time_remaining.minutes": "Mazal {number, plural, one {# n tesdat} other {# n tesdatin}}",
  "time_remaining.moments": "Akuden i d-yeqqimen",
  "time_remaining.seconds": "Mazal {number, plural, one {# n tasint} other {# n tsinin}} id yugran",
  "trends.counter_by_accounts": "{count, plural, one {{counter} wemdan} other {{counter} medden}} deg {days, plural, one {ass} other {{days} wussan}} iɛeddan",
  "trends.trending_now": "Anezzuɣ tura",
  "ui.beforeunload": "Arewway-ik·im ad iruḥ ma yella tefeɣ-d deg Maṣṭudun.",
  "units.short.billion": "{count}B",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Zuḥeb rnu sers i tasalyt",
  "upload_button.label": "Rnu taɣwalt",
  "upload_error.limit": "Asali n ufaylu iεedda talast.",
  "upload_error.poll": "Ur ittusireg ara usali n ufaylu s tefranin.",
  "upload_form.edit": "Ẓreg",
  "upload_progress.label": "Asali iteddu...",
  "upload_progress.processing": "Asesfer…",
  "username.taken": "Yettwaṭṭef yisem-a n useqdac. Ɛreḍ wayeḍ",
  "video.close": "Mdel tabidyutt",
  "video.download": "Sidered afaylu",
  "video.exit_fullscreen": "Ffeɣ seg ugdil ačuran",
  "video.expand": "Semɣeṛ tavidyut",
  "video.fullscreen": "Agdil aččuran",
  "video.hide": "Ffer tabidyutt",
  "video.mute": "Sgugem",
  "video.pause": "Sgunfu",
  "video.play": "Seddu",
  "video.skip_backward": "Uɣal ɣer deffir",
  "video.skip_forward": "Ddu ɣer zdat",
  "video.unmute": "Kkes asgugem",
  "visibility_modal.button_title": "Sbadu abani",
  "visibility_modal.privacy_label": "Abani",
  "visibility_modal.quote_followers": "Imeḍfaṛen kan",
  "visibility_modal.quote_label": "Anwa i izemren ad d-yebder",
  "visibility_modal.quote_nobody": "Nekki kan",
  "visibility_modal.quote_public": "Yal yiwen",
  "visibility_modal.save": "Sekles"
}
